"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NodeList = require("../generated/NodeList"); // https://dom.spec.whatwg.org/#mutationrecord


var MutationRecordImpl = /*#__PURE__*/function () {
  function MutationRecordImpl(globalObject, args, privateData) {
    _classCallCheck(this, MutationRecordImpl);

    this._globalObject = globalObject;
    this.type = privateData.type;
    this.target = privateData.target;
    this.previousSibling = privateData.previousSibling;
    this.nextSibling = privateData.nextSibling;
    this.attributeName = privateData.attributeName;
    this.attributeNamespace = privateData.attributeNamespace;
    this.oldValue = privateData.oldValue;
    this._addedNodes = privateData.addedNodes;
    this._removedNodes = privateData.removedNodes;
  }

  _createClass(MutationRecordImpl, [{
    key: "addedNodes",
    get: function get() {
      return NodeList.createImpl(this._globalObject, [], {
        nodes: this._addedNodes
      });
    }
  }, {
    key: "removedNodes",
    get: function get() {
      return NodeList.createImpl(this._globalObject, [], {
        nodes: this._removedNodes
      });
    }
  }]);

  return MutationRecordImpl;
}();

module.exports = {
  implementation: MutationRecordImpl
};